import React, { Component } from 'react';
import { connect } from 'react-redux';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { BasicLazyParams } from '../../../utile';
import Authentication from '../../session';

import { ActiveTag, BoardsIconInActive, CancelRed, CrossInBox, GreenCheck, InactiveTag, PopupGreeTick } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from '../../../store/apiConstants';
import withRouter from '../../lib/withRouter';
import { RadioButton } from 'primereact/radiobutton';
import { debounce } from 'lodash';
import BranchToSectionApprovalHierarchy from '../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';
import { getBranchesLatest } from '../../../store/actions';

import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import './styles.scss';

class StudentPromotions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            lazyParams: BasicLazyParams,
            promotionRequests: [],
            allPromotionRequests: [],
            totalRecords: 0,
            isApprovePromotionDialogOpen: false,
            isRejectPromotionDialogOpen: false,
            rowData: {},
            dropdownsData: {},
            flagForPromotion: null,
            searchValue: '',
            dropdownsDilogData: {},
            selectedRows: new Map(),
            selectAll: false,
            selectedPromotionsForAction: [], // Single array for both single and bulk
            remarks: '',
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'studentName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'enrollmentNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'branch': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
            },
            globalFilterValue: '',
            capacityErrors: [],
            showCapacityErrors: false,
            studentsWithDues: [],
            showDuesErrors: false,
            validationResult: null,
            // Removed isSinglePromotion - no longer needed
        };
        this.debouncedApiCall = debounce(this.filterPromotionData, 500);
        this.service = new Service();
    }

    setDropdownValues = (dropdownsData) => {
        // Reset selections when dropdown values change
        this.setState({
            dropdownsData,
            selectedRows: new Map(),
            selectAll: false
        }, () => {
            this.applyFrontendFilters();
        });
    };

    filterPromotionData = () => {
        this.setState({ isLoading: true, promotionRequests: [], allPromotionRequests: [] });

        const url = `${baseUrlAdmin}/promotions/approval-requests`;

        // Include hierarchy data in the request payload for level-based filtering
        const payload = {
            currentAcademicYear: localStorage.getItem('userAcademicYear'),
            assignedHeirarchy: this.state.dropdownsData?.heirarchy || null
        };

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res?.status && res.res?.status) {
                    const data = res.res?.data || [];

                    this.setState({
                        isLoading: false,
                        allPromotionRequests: data, // Store all data
                        totalRecords: data.length
                    }, () => {
                        // Apply filters after data is loaded
                        this.applyFrontendFilters();
                    });
                } else {
                    throw new Error(res.errMessage || 'An error occurred');
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            });
    };

    applyFrontendFilters = () => {
        const { allPromotionRequests, dropdownsData, globalFilterValue } = this.state;

        if (!allPromotionRequests || allPromotionRequests.length === 0) {
            return;
        }

        let filteredData = [...allPromotionRequests];

        // Apply branch filter (multi-select)
        if (dropdownsData?.branchIds && dropdownsData.branchIds.length > 0) {
            filteredData = filteredData.filter(item =>
                dropdownsData.branchIds.includes(item.currentBranchId) ||
                dropdownsData.branchIds.includes(item.targetBranchId)
            );
        }

        // Apply board filter (multi-select)
        if (dropdownsData?.boardIds && dropdownsData.boardIds.length > 0) {
            filteredData = filteredData.filter(item =>
                dropdownsData.boardIds.includes(item.currentBoardId) ||
                dropdownsData.boardIds.includes(item.targetBoardId)
            );
        }

        // Apply class/grade filter (multi-select)
        if (dropdownsData?.classIds && dropdownsData.classIds.length > 0) {
            filteredData = filteredData.filter(item =>
                dropdownsData.classIds.includes(item.currentClassId) ||
                dropdownsData.classIds.includes(item.targetClassId)
            );
        }

        // Apply section filter (single select)
        if (dropdownsData?.sectionId) {
            filteredData = filteredData.filter(item =>
                item.currentSectionId === dropdownsData.sectionId ||
                item.targetSectionId === dropdownsData.sectionId
            );
        }

        // Apply global search filter
        if (globalFilterValue) {
            filteredData = filteredData.filter(item =>
                item.studentName?.toLowerCase().includes(globalFilterValue.toLowerCase()) ||
                item.enrollmentNo?.toLowerCase().includes(globalFilterValue.toLowerCase()) ||
                item.branch?.toLowerCase().includes(globalFilterValue.toLowerCase())
            );
        }

        this.setState({
            promotionRequests: filteredData,
            totalRecords: filteredData.length
        }, () => {
            this.updateSelectAllState();
        });
    };

    componentDidMount() {
        this.filterPromotionData();
    }

    onPage = (event) => {
        this.setState(
            (prevState) => ({
                lazyParams: { ...prevState.lazyParams, ...event }
            }),
            () => {
                this.updateSelectAllState();
            }
        );
    }

    onSort = (event) => {
        this.setState(
            (prevState) => ({
                lazyParams: { ...prevState.lazyParams, ...event }
            })
        );
    }

    onFilter = (event) => {
        event['first'] = 0;
        this.setState(
            (prevState) => ({
                lazyParams: { ...prevState.lazyParams, filters: event.filters }
            })
        );
    };

    // Handle individual row selection
    onRowSelect = (rowData, checked) => {
        const newSelectedRows = new Map(this.state.selectedRows);

        if (checked) {
            newSelectedRows.set(rowData._id, rowData);
        } else {
            newSelectedRows.delete(rowData._id);
        }

        this.setState({
            selectedRows: newSelectedRows
        }, () => {
            this.updateSelectAllState();
        });
    };

    // Handle select all for current page only
    onSelectAllCurrentPage = (checked) => {
        const newSelectedRows = new Map(this.state.selectedRows);
        const currentPageData = this.getCurrentPageData();

        if (checked) {
            // Add all current page promotion requests
            currentPageData.forEach(request => {
                newSelectedRows.set(request._id, request);
            });
        } else {
            // Remove all current page promotion requests
            currentPageData.forEach(request => {
                newSelectedRows.delete(request._id);
            });
        }

        this.setState({
            selectedRows: newSelectedRows
        }, () => {
            this.updateSelectAllState();
        });
    };

    updateSelectAllState = () => {
        const currentPageData = this.getCurrentPageData();
        const currentPageSelected = currentPageData.length > 0 &&
            currentPageData.every(request => this.state.selectedRows.has(request._id));

        this.setState({
            selectAll: currentPageSelected
        });
    };

    getCurrentPageData = () => {
        const { promotionRequests, lazyParams } = this.state;
        const start = lazyParams.first || 0;
        const end = start + (lazyParams.rows || 10);
        return promotionRequests.slice(start, end);
    };

    // Template for selection checkbox
    selectionTemplate = (rowData) => {
        const isSelected = this.state.selectedRows.has(rowData._id);

        return (
            <Checkbox
                checked={isSelected}
                onChange={(e) => this.onRowSelect(rowData, e.checked)}
            />
        );
    };

    selectAllTemplate = () => {
        return (
            <Checkbox
                checked={this.state.selectAll}
                onChange={(e) => this.onSelectAllCurrentPage(e.checked)}
            />
        );
    };

    // Handle single promotion actions
    handleSinglePromotionAction = (promotionData, actionType) => {
        if (actionType === 'APPROVE') {
            // Validate both section strength and dues before showing approve dialog
            this.validatePromotionRequests([promotionData._id], () => {
                this.setState({
                    isApprovePromotionDialogOpen: true,
                    selectedPromotionsForAction: [promotionData], // Single item array
                    flagForPromotion: 'APPROVE'
                });
            });
        } else if (actionType === 'REJECT') {
            this.setState({
                isRejectPromotionDialogOpen: true,
                selectedPromotionsForAction: [promotionData], // Single item array
                flagForPromotion: 'REJECT'
            });
        }
    };

    // Handle bulk approve - show dialog instead of direct processing
    handleBulkApprove = () => {
        const selectedCount = this.state.selectedRows.size;

        if (selectedCount === 0) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please select at least one promotion request to approve',
                life: 3000
            });
            return;
        }

        const promotionIds = Array.from(this.state.selectedRows.keys());

        // Validate both section strength and dues before showing bulk approve dialog
        this.validatePromotionRequests(promotionIds, () => {
            this.setState({
                isApprovePromotionDialogOpen: true,
                selectedPromotionsForAction: Array.from(this.state.selectedRows.values()), // Multiple items array
                flagForPromotion: 'APPROVE'
            });
        });
    };

    validatePromotionRequests = (promotionIds, onSuccess) => {
        if (!promotionIds || promotionIds.length === 0) {
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No promotion requests selected for validation',
                life: 3000
            });
            return;
        }

        this.setState({
            isLoading: true,
            showCapacityErrors: false,
            capacityErrors: [],
            showDuesErrors: false,
            studentsWithDues: [],
            validationResult: null
            // Removed eligiblePromotionIds
        });

        const url = `${baseUrlAdmin}/promotions/validate-promotion-requests`;
        const payload = { promotionIds };

        this.service
            .post(url, payload, true)
            .then((res) => {
                this.setState({ isLoading: false });

                if (res?.status && res?.res?.status) {
                    const validationResult = res.res;
                    console.log('Promotion validation result:', validationResult);

                    this.setState({
                        validationResult
                        // Removed eligiblePromotionIds
                    });

                    let hasCapacityErrors = false;

                    // Check capacity validation only
                    if (validationResult.capacityValidation && !validationResult.capacityValidation.isValid) {
                        this.setState({
                            capacityErrors: validationResult.capacityValidation.capacityErrors || [],
                            showCapacityErrors: true
                        });

                        this.toast.show({
                            severity: 'error',
                            summary: 'Capacity Error',
                            detail: 'Some sections do not have sufficient capacity for the promotions',
                            life: 5000
                        });
                        hasCapacityErrors = true;
                    }

                    // Store dues information for display purposes only (not for blocking)
                    if (validationResult.duesValidation && validationResult.duesValidation.studentsWithDues && validationResult.duesValidation.studentsWithDues.length > 0) {
                        this.setState({
                            studentsWithDues: validationResult.duesValidation.studentsWithDues,
                            showDuesErrors: true
                        });

                        if (!hasCapacityErrors) {
                            this.toast.show({
                                severity: 'info',
                                summary: 'Dues Information',
                                detail: `${validationResult.duesValidation.studentsWithDuesCount} student(s) have pending dues but will still be promoted`,
                                life: 5000
                            });
                        }
                    }

                    // If no capacity errors, proceed with dialog (dues don't block promotion)
                    if (!hasCapacityErrors && onSuccess) {
                        onSuccess();
                    }
                } else {
                    throw new Error(res.message || 'Promotion validation failed');
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: error.message || 'Failed to validate promotion requests',
                    life: 3000
                });
            });
    };

    // Render capacity errors (existing method)
    renderCapacityErrors = () => {
        const { capacityErrors, showCapacityErrors } = this.state;

        if (!showCapacityErrors || !capacityErrors || capacityErrors.length === 0) {
            return null;
        }

        return (
            <div className="capacity-error-container">
                <div className="capacity-error-header">
                    <i className="pi pi-exclamation-triangle capacity-error-icon"></i>
                    <strong>Section Capacity Exceeded</strong>
                </div>
                <p className="mb-2">The following sections do not have sufficient capacity for the selected promotions:</p>
                <ul className="capacity-error-list">
                    {capacityErrors.map((error, index) => (
                        <li key={index} className="capacity-error-item">
                            <div className="flex justify-content-between align-items-center">
                                <div>
                                    <strong>{error.branchName} - {error.sectionName}</strong>
                                    <br />
                                    <span className="text-sm">Academic Year: {error.academicYear}</span>
                                </div>
                                <div className="text-right text-sm">
                                    <div>Current: {error.currentStrength}/{error.maxStrength}</div>
                                    <div>Remaining: {error.remainingCapacity}</div>
                                    <div style={{ color: '#dc3545' }}>
                                        <strong>Excess: {error.excess} students</strong>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className="capacity-error-summary">
                    <strong>Summary:</strong> {capacityErrors.length} section(s) cannot accommodate the selected promotions.
                    Please update the section(s) capacity or select fewer students.
                </div>
                <div className="mt-2 text-right">
                    <Button
                        className="p-button-sm capacity-error-dismiss-btn"
                        onClick={() => this.setState({ showCapacityErrors: false, capacityErrors: [] })}
                    >
                        <i className="pi pi-times mr-1"></i>
                        Dismiss
                    </Button>
                </div>
            </div>
        );
    };

    processPromotionAction = (actionType) => {
        const {
            selectedPromotionsForAction,
            remarks,
            validationResult,
            dropdownsData
        } = this.state;

        if (!selectedPromotionsForAction || selectedPromotionsForAction.length === 0) {
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No promotion requests selected',
                life: 3000
            });
            return;
        }

        const promotionIds = selectedPromotionsForAction.map(promotion => promotion._id);
        const isStingle = selectedPromotionsForAction.length === 1;

        // Get level and branch details from hierarchy data
        const levelAndBranchDetails = dropdownsData?.heirarchy?.adminLevels?.filter((al) => 
            selectedPromotionsForAction.some(promotion => 
                al._id === promotion.currentBranchId || al._id === promotion.targetBranchId
            )
        ) || [];

        let url, payload;

        if (actionType === 'APPROVE') {
            url = `${baseUrlAdmin}/promotions/approve-student-promotion`;
            payload = { 
                promotionIds,
                levelAndBranchDetails
            };
        } else if (actionType === 'REJECT') {
            url = `${baseUrlAdmin}/promotions/reject-student-promotions`;
            payload = {
                promotionIds,
                remarks: remarks || '',
                levelAndBranchDetails
            };
        }

        this.setState({ isLoading: true });

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res?.status && res?.res?.status) {
                    this.setState({
                        isApprovePromotionDialogOpen: false,
                        isRejectPromotionDialogOpen: false,
                        selectedRows: new Map(),
                        selectedPromotionsForAction: [],
                        remarks: '',
                        isLoading: false,
                        selectAll: false,
                        showCapacityErrors: false,
                        capacityErrors: [],
                        showDuesErrors: false,
                        studentsWithDues: [],
                        validationResult: null
                    });

                    const actionText = actionType === 'APPROVE' ? 'approved' : 'rejected';
                    const countText = isStingle ? 'promotion request' : `${promotionIds.length} promotion requests`;

                    // Updated message for dues - now informational only
                    let detailMessage = `Successfully ${actionText} ${countText}`;
                    if (!isStingle && validationResult?.duesValidation?.studentsWithDuesCount > 0) {
                        detailMessage += `. ${validationResult.duesValidation.studentsWithDuesCount} students with dues were also promoted.`;
                    }

                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: detailMessage,
                        life: 5000
                    });

                    this.filterPromotionData();
                } else {
                    throw new Error(res.message || 'An error occurred');
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000
                });
            });
    };

    // Update existing updatePromotion method to use new process
    updatePromotion = (approveStatus) => {
        // Add validation for remarks when rejecting
        if (approveStatus === 'REJECT' && (!this.state.remarks || this.state.remarks.trim() === '')) {
            this.toast.show({
                severity: 'warn',
                summary: 'Validation Error',
                detail: 'Remarks are mandatory when rejecting a promotion request',
                life: 3000
            });
            return;
        }

        this.setState({
            flagForPromotion: approveStatus
        }, () => {
            this.processPromotionAction(approveStatus);
        });
    };

    handleSetSearchTypeValue = (value) => {
        this.setState({ searchType: value });
    };

    handleSetSearchValue = (value) => {
        this.setState({ searchValue: value }, () => {
            this.debouncedApiCall();
        });
    };

    renderHeader() {
        const selectedCount = this.state.selectedRows.size;

        return (
            <div className="flex flex-column gap-3">
                {/* Search Input and Bulk Approve Button */}
                <div className="flex justify-content-between align-items-center">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText
                            value={this.state.globalFilterValue}
                            onChange={this.onGlobalFilterChange}
                            placeholder="Search Student Name/Enrollment Number/Branch"
                        />
                    </span>

                    <Button
                        className="bulk-approve-btn"
                        disabled={selectedCount === 0}
                        onClick={this.handleBulkApprove}
                    >
                        Approve Selected Requests
                        {/* ({selectedCount}) */}
                    </Button>
                </div>
            </div>
        )
    }

    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        this.setState({ globalFilterValue: value }, () => {
            this.applyFrontendFilters();
        });
    };

    hasStudentDues = (promotionId) => {
        const { studentsWithDues } = this.state;
        return studentsWithDues.some(student => student.promotionId === promotionId);
    };

    getStudentDues = (promotionId) => {
        const { studentsWithDues } = this.state;
        const student = studentsWithDues.find(student => student.promotionId === promotionId);
        return student ? student.totalDues : 0;
    };

    render() {
        const header = this.renderHeader();
        const {
            promotionRequests,
            isLoading,
            isApprovePromotionDialogOpen,
            isRejectPromotionDialogOpen,
            selectedPromotionsForAction,
            studentsWithDues,
            validationResult
        } = this.state;

        const isSingle = selectedPromotionsForAction.length === 1;

        return (
            <div>
                <div className="ma-main">
                    <div className="datatable-crud-demo ma-m30 mx-2 mb-5">
                        <div className="flex">
                            <div className="w-full">
                                <BranchToSectionApprovalHierarchy
                                    selectedValue={1}
                                    setValues={this.setDropdownValues}
                                    approvalType={'studentPromotions'}
                                    autoSelectDefaults={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card datatable-crud-demo ma-m30 m-2">
                        {/* Add capacity errors display here */}
                        {this.renderCapacityErrors()}

                        <DataTable
                            ref={(el) => (this.dt = el)}
                            value={promotionRequests}
                            dataKey="_id"
                            paginator
                            className="dataTableValuesText"
                            responsiveLayout="scroll"
                            showGridlines
                            columnResizeMode="expand"
                            resizableColumns
                            onPage={this.onPage}
                            first={this.state.lazyParams.first}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            lazy={false}
                            header={header}
                            filters={this.state.filters}
                            filterDisplay="menu"
                            loading={this.state.isLoading}
                            globalFilterFields={[
                                'studentName',
                                'enrollmentNo',
                                'branch'
                            ]}
                            emptyMessage="No promotion requests found matching the selected criteria."
                        >
                            {/* DataTable columns remain the same */}
                            <Column
                                header={this.selectAllTemplate}
                                body={this.selectionTemplate}
                                style={{ width: '4rem' }}
                                headerStyle={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '1rem',
                                }}
                                bodyClassName="text-center"
                            />

                            <Column
                                style={{ width: '12rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="studentName"
                                header="Student Name"
                            />
                            <Column
                                style={{ width: '12rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="enrollmentNo"
                                header="Enrollment No."
                            />
                            <Column
                                style={{ width: '10rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="branch"
                                header="Branch"
                            />
                            <Column
                                style={{ width: '12rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="currentBoard"
                                header="Current Board"
                            />
                            <Column
                                style={{ width: '14rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="currentGradeSection"
                                header="Current Grade-Section"
                            />
                            <Column
                                style={{ width: '12rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="targetBoard"
                                header="Target Board"
                            />
                            <Column
                                style={{ width: '14rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="targetGradeSection"
                                header="Target Grade-Section"
                            />
                            <Column
                                style={{ width: '14rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center body-medium"
                                field="targetAcademicYear"
                                header="Target Academic Year"
                            />
                            <Column
                                style={{ width: '15rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary body-small-semibold"
                                bodyClassName="text-center"
                                header="Approve / Reject"
                                body={(rowData) => (
                                    <div className="flex justify-content-evenly">
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => this.handleSinglePromotionAction(rowData, 'APPROVE')}
                                        >
                                            <GreenCheck />
                                        </div>
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => this.handleSinglePromotionAction(rowData, 'REJECT')}
                                        >
                                            <CancelRed />
                                        </div>
                                    </div>
                                )}
                            />
                        </DataTable>

                        <Toast ref={(el) => (this.toast = el)} position="bottom-right" />

                        <Dialog
                            visible={isApprovePromotionDialogOpen}
                            // style={{ width: 600, maxHeight: '80vh' }}
                            draggable={false}
                            resizable={false}
                            contentStyle={{ padding: 0 }}
                            breakpoints={{ '960px': '90vw' }}
                            style={{
                                // width: '90vw', 
                                // maxWidth: '1000px', 
                                borderRadius: '16px',
                                padding: 20,
                                overflow: 'hidden',
                                backgroundColor: 'white'
                            }}
                            header={() => (
                                <div className="mt-2 formHeadingInter" style={{ textAlign: 'center' }}>
                                    <div className="mb-3">
                                        <PopupGreeTick />
                                    </div>
                                    <p style={{ fontWeight: 'bold', fontSize: 20 }}>
                                        {isSingle ? 'Approve Promotion' : 'Bulk Approve Promotions'}
                                    </p>
                                </div>
                            )}
                            footer={() => (
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                                    <Button
                                        style={{
                                            borderRadius: 10,
                                            backgroundColor: '#076EFF',
                                            width: isSingle ? '120px' : '150px',
                                            padding: '10px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: 'none',
                                            color: 'white'
                                        }}
                                        onClick={() => this.processPromotionAction('APPROVE')}
                                    >
                                        <p className="text-xl" style={{ margin: 0 }}>
                                            {isSingle ? 'Approve' : `Approve All (${selectedPromotionsForAction.length})`}
                                        </p>
                                    </Button>
                                    <Button
                                        style={{
                                            borderRadius: 10,
                                            backgroundColor: '#f5f5f5',
                                            width: '100px',
                                            padding: '10px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: 'none',
                                            color: '#333'
                                        }}
                                        onClick={() => this.setState({ isApprovePromotionDialogOpen: false })}
                                    >
                                        <p className="text-xl" style={{ margin: 0 }}>Cancel</p>
                                    </Button>
                                </div>
                            )}
                            onHide={() => this.setState({ isApprovePromotionDialogOpen: false })}
                        >
                            <div className="topicName" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10, textAlign: 'center' }}>
                                <div className="mb-3">
                                    {validationResult && !isSingle && (
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '8px' }}>
                                            <span style={{ color: '#28a745', fontWeight: 'bold' }}>
                                                All Selected: {selectedPromotionsForAction.length}
                                            </span>
                                            {studentsWithDues.length > 0 && (
                                                <span style={{ color: '#ff9800', fontWeight: 'bold' }}>
                                                    With Dues: {studentsWithDues.length}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {isSingle ? (
                                    // Single promotion details in table format
                                    <div style={{ textAlign: 'center' }}>
                                        <table style={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                            margin: '0 auto 20px auto',
                                            border: '1px solid #e0e0e0'
                                        }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        fontWeight: 'bold',
                                                        border: '1px solid #e0e0e0',
                                                        width: '40%'
                                                    }}>
                                                        Student Name
                                                    </td>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        {selectedPromotionsForAction[0]?.studentName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        fontWeight: 'bold',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        Enrollment No
                                                    </td>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        {selectedPromotionsForAction[0]?.enrollmentNo}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        fontWeight: 'bold',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        Branch
                                                    </td>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        {selectedPromotionsForAction[0]?.branch}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        fontWeight: 'bold',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        Current
                                                    </td>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        {selectedPromotionsForAction[0]?.currentGradeSection} ({selectedPromotionsForAction[0]?.currentAcademicYear})
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        fontWeight: 'bold',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        Target
                                                    </td>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        {selectedPromotionsForAction[0]?.targetGradeSection} ({selectedPromotionsForAction[0]?.targetAcademicYear})
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        fontWeight: 'bold',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        Request Raised by
                                                    </td>
                                                    <td style={{
                                                        padding: '12px',
                                                        textAlign: 'left',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        {selectedPromotionsForAction[0]?.requestRaisedByName}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {this.hasStudentDues(selectedPromotionsForAction[0]?._id) && (
                                            <div className="mt-3 p-2" style={{
                                                backgroundColor: 'white',
                                                // border: '1px solid ',
                                                borderRadius: '4px',
                                                color: 'red'
                                            }}>
                                                <i className="pi pi-info-circle mr-2"></i>
                                                <strong>Warning:</strong> This student has pending dues of ₹{this.getStudentDues(selectedPromotionsForAction[0]?._id)?.toLocaleString()} but will still be promoted.
                                            </div>
                                        )}

                                        {/* <p style={{ color: 'green' }} className="mt-3">
                                            *Promote student to {selectedPromotionsForAction[0]?.targetGradeSection} ({selectedPromotionsForAction[0]?.targetAcademicYear})
                                        </p> */}
                                    </div>
                                ) : (
                                    // Bulk promotion details
                                    <div>
                                        <div style={{
                                            maxHeight: '300px',
                                            overflowY: 'auto',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            padding: '10px',
                                            margin: '0 auto',
                                            width: '100%'
                                        }}>
                                            {selectedPromotionsForAction?.map((promotion, index) => {
                                                const hasDues = this.hasStudentDues(promotion._id);
                                                const duesAmount = this.getStudentDues(promotion._id);

                                                return (
                                                    <div key={promotion._id} style={{
                                                        backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                                                        padding: '8px',
                                                        borderRadius: '4px',
                                                        marginBottom: '5px',
                                                        border: hasDues ? '1px solid #ff9800' : 'none'
                                                    }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <div style={{ textAlign: 'left' }}>
                                                                <p style={{ margin: '2px 0', fontSize: '14px' }}>
                                                                    <strong>{index + 1}. {promotion.studentName}</strong> ({promotion.enrollmentNo})
                                                                </p>
                                                                <p style={{ margin: '2px 0', fontSize: '12px', color: '#666' }}>
                                                                    {promotion.currentGradeSection} ({promotion.currentAcademicYear}) → {promotion.targetGradeSection} ({promotion.targetAcademicYear})
                                                                </p>
                                                            </div>
                                                            <div>
                                                                {hasDues ? (
                                                                    <div style={{ textAlign: 'right' }}>
                                                                        <div style={{
                                                                            backgroundColor: '#fff3cd',
                                                                            color: '#856404',
                                                                            padding: '2px 6px',
                                                                            borderRadius: '4px',
                                                                            fontSize: '11px',
                                                                            fontWeight: 'bold'
                                                                        }}>
                                                                            HAS DUES
                                                                        </div>
                                                                        <div style={{ fontSize: '10px', color: '#ff9800' }}>
                                                                            ₹{duesAmount?.toLocaleString()}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div style={{
                                                                        backgroundColor: '#d4edda',
                                                                        color: '#155724',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '11px',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        ELIGIBLE
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        <div style={{ textAlign: 'center', marginTop: '12px' }}>
                                            <p style={{ color: 'green', fontSize: '14px', fontWeight: 'bold', margin: 0 }}>
                                                *All {selectedPromotionsForAction.length} students will be promoted
                                                {studentsWithDues.length > 0 && ` (including ${studentsWithDues.length} students with pending dues)`}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Dialog>

                        {/* Reject Dialog */}
                        <Dialog
                            visible={isRejectPromotionDialogOpen}
                            style={{ width: 400 }}
                            header={() => (
                                <div className="mt-2 formHeadingInter" style={{ textAlign: 'center' }}>
                                    <div className="mb-3">
                                        <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                    </div>
                                    <p style={{ fontWeight: 'bold', fontSize: 20 }}>Reject Promotion</p>
                                </div>
                            )}
                            footer={() => (
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                                    <Button
                                        style={{
                                            borderRadius: 10,
                                            backgroundColor: '#BF0031',
                                            width: '120px',
                                            padding: '10px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: 'none',
                                            color: 'white'
                                        }}
                                        onClick={() => this.updatePromotion('REJECT')}
                                    >
                                        <p className="text-xl" style={{ margin: 0 }}>Reject</p>
                                    </Button>
                                    <Button
                                        style={{
                                            borderRadius: 10,
                                            backgroundColor: '#f5f5f5',
                                            width: '100px',
                                            padding: '10px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: 'none',
                                            color: '#333'
                                        }}
                                        onClick={() => this.setState({ isRejectPromotionDialogOpen: false })}
                                    >
                                        <p className="text-xl" style={{ margin: 0 }}>Cancel</p>
                                    </Button>
                                </div>
                            )}
                            onHide={() => this.setState({ isRejectPromotionDialogOpen: false })}
                        >
                            <div className="topicName" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10, textAlign: 'center' }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    margin: '0 auto 20px auto',
                                    border: '1px solid #e0e0e0'
                                }}>
                                    <tbody>
                                        <tr>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                border: '1px solid #e0e0e0',
                                                width: '40%'
                                            }}>
                                                Student Name
                                            </td>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                {selectedPromotionsForAction[0]?.studentName}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                Enrollment No
                                            </td>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                {selectedPromotionsForAction[0]?.enrollmentNo}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                Branch
                                            </td>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                {selectedPromotionsForAction[0]?.branch}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                Current
                                            </td>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                {selectedPromotionsForAction[0]?.currentGradeSection} ({selectedPromotionsForAction[0]?.currentAcademicYear})
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                Target
                                            </td>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                {selectedPromotionsForAction[0]?.targetGradeSection} ({selectedPromotionsForAction[0]?.targetAcademicYear})
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                Request Raised by
                                            </td>
                                            <td style={{
                                                padding: '12px',
                                                textAlign: 'left',
                                                border: '1px solid #e0e0e0'
                                            }}>
                                                {selectedPromotionsForAction[0]?.requestRaisedByName}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="mt-3" style={{ textAlign: 'left' }}>
                                    <label htmlFor="remarks" className="block text-sm font-medium mb-2">
                                        Remarks: <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <textarea
                                        id="remarks"
                                        className="w-full p-2 border border-gray-300 rounded"
                                        rows="3"
                                        placeholder="Enter reason for rejection (required)"
                                        value={this.state.remarks}
                                        onChange={(e) => this.setState({ remarks: e.target.value })}
                                        style={{
                                            borderColor: this.state.remarks.trim() === '' ? '#dc3545' : '#ced4da'
                                        }}
                                    />
                                </div>
                            </div>
                        </Dialog>
                        {isLoading && <LoadingComponent />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    branchData: (state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each) => each.level === 1)) || []
});

export default connect(mapStatesToProps, {
    getBranchesLatest
})(Authentication(withRouter(StudentPromotions)));